export default "__VITE_ASSET__ClmG055j__"